import { Check } from "lucide-react";

const money = (n) => `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function labelQuoteHref(spec, quantity) {
  if (!spec) return "/quote";
  const q = new URLSearchParams({ topic: "label-quote", product: spec.product || "", size: `${spec.width_in || ""} x ${spec.height_in || ""} in`,
    shape: spec.shape || "", material: spec.material || "", lamination: spec.lamination || "", foil: spec.foil || "",
    qty: String(quantity || "") });
  return `/quote?${q.toString()}`;
}

export function LabelPriceLadder({ price, quantity, onPick, compact = false, spec }) {
  const rows = price?.ladder;
  if (!rows?.length) return null;
  const lm = price.label_model || {};
  const quoteHref = labelQuoteHref(spec, lm.quote_required_above ? Math.max(Number(quantity) || 0, lm.quote_required_above) : quantity);
  return (
    <div className={compact ? "mt-4" : "p-0"} data-testid="label-price-ladder">
      {!compact && (
        <div className="px-6 pt-5 pb-3">
          <div className="overline">Quantity breaks</div>
          <p className="text-sm text-slate-500 mt-1">
            Prices for your current size, material and finishes. Click a row to set the quantity.
            {lm.custom_die_fee > 0 && <> Includes a one-time ${lm.custom_die_fee} custom die.</>}
          </p>
        </div>
      )}
      <table className="w-full text-sm" data-testid="label-ladder-table">
        <thead>
          <tr className="text-[10px] font-mono uppercase tracking-widest text-slate-500 text-left border-b border-slate-200">
            <th className={compact ? "py-1.5" : "px-6 py-2"}>Quantity</th>
            <th className="py-2">Price per label</th>
            <th className="py-2 text-right pr-6">Total</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const active = Number(quantity) === r.quantity;
            return (
              <tr key={r.quantity} onClick={() => onPick?.(r.quantity)} data-testid={`label-ladder-row-${r.quantity}`}
                className={`cursor-pointer border-b border-slate-100 transition-colors duration-150 ${active ? "bg-[#DD6B33]/10" : "hover:bg-slate-50"}`}>
                <td className={`${compact ? "py-1.5" : "px-6 py-2.5"} font-mono font-bold text-[#333F48]`}>
                  <span className="inline-flex items-center gap-1.5">{active && <Check className="w-3.5 h-3.5 text-[#DD6B33]" />}{r.quantity.toLocaleString()}</span>
                </td>
                <td className="py-2 font-mono text-slate-600">${Number(r.unit_price).toFixed(4)}</td>
                <td className="py-2 pr-6 text-right font-display font-bold text-[#333F48]">{money(r.price)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {lm.quote_required_above && (
        <div className={`${compact ? "" : "px-6"} py-3 text-xs text-slate-500`} data-testid="label-ladder-quote-note">
          Need more than {Number(lm.quote_required_above).toLocaleString()}? <a href={quoteHref} data-testid="label-ladder-quote-link" className="text-[#DD6B33] font-semibold hover:underline">Request a custom quote</a>.
        </div>
      )}
    </div>
  );
}
